// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // apiScar: 'http://localhost:56909/',
  //DESARROLLO
  // apiScar: 'http://10.6.95.45:61/',
  //apimailing: 'http://10.6.95.45:190/'
  // CALIDAD
  apiScar: 'https://pruebas-apisiicart.aguapuebla.mx/',
  apimailing: 'https://pruebas-apimailing.aguapuebla.mx/',
  servRESTGIS: 'https://arcgisouc.aguapuebla.mx/arcgis/rest/services/Calidad/',
  // PRODUCCION
  // apiScar: 'https://apisiicart.aguapuebla.mx/',
  // apimailing: 'https://apimailing.aguapuebla.mx/',
  // servRESTGIS: 'https://arcgisouc.aguapuebla.mx/arcgis/rest/services/Produccion/'

}
console.log("V.1.0.1 PRO-DDS-6857-20250403")

// console.log("V.1.0.3.P1")
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
